import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
export function VSL() {
  const [isPlaying, setIsPlaying] = useState(false);
  return <section id="vsl" className="bg-black py-20 md:py-24 px-4 sm:px-6 lg:px-8 border-t border-white/5 overflow-hidden" data-id="element-307" data-mp="734pliafrsv8">
      <div className="max-w-7xl mx-auto" data-id="element-308" data-mp="buwfrrpojwku">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-16" data-id="element-309" data-mp="bvxq1tyvgf1i">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-310" data-mp="2rl0jyx1uplkz">
            Descubre el Método
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight leading-[1.1] mb-6" data-id="element-311" data-mp="1n4hwlgstpq7s">
            Mira como
            <br data-id="element-312" data-mp="1ic6uc7am1sc2" />
            <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-313" data-mp="1ibouz1snixzx">
              lo logramos.
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/60 font-light max-w-2xl mx-auto" data-id="element-314" data-mp="19duvxj3i5q92">
            En unos minutos descubre exactamente cómo transformamos tu crédito y
            aseguramos tu financiamiento.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 40
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative max-w-5xl mx-auto" data-id="element-315" data-mp="1x25tac9zp7sl">
          <div className="relative aspect-video rounded-3xl overflow-hidden bg-[#111] shadow-2xl shadow-amber-500/10 ring-1 ring-white/10" data-id="element-316" data-mp="i5ur3z8di733">
            {!isPlaying ? <>
                <div className="absolute inset-0 bg-cover bg-center" style={{
              backgroundImage: "url('https://cdn.magicpatterns.com/uploads/iscmunNCTmj2gaCHihABZz/Captura_de_pantalla_2026-06-01_a_la(s)_9.56.15_p.m..png')"
            }} data-id="element-317" data-mp="93v9b4pjayz3" />
                <div className="absolute inset-0 bg-black/50" data-id="element-318" data-mp="3mj9r40micuw1" />

                <button onClick={() => setIsPlaying(true)} className="absolute inset-0 flex items-center justify-center group/play" aria-label="Reproducir video" data-id="element-319" data-mp="3mkui5g9m5vp5">
                  <div className="relative" data-id="element-320" data-mp="3hk6tv2crrsym">
                    <div className="absolute inset-0 rounded-full bg-amber-400/30 animate-ping" data-id="element-321" data-mp="3hivgqbxfp8uu" />
                    <div className="relative h-20 w-20 md:h-24 md:w-24 rounded-full bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 flex items-center justify-center group-hover/play:scale-110 transition-transform duration-300 shadow-2xl shadow-amber-500/40" data-id="element-322" data-mp="2xz6cc2i2jyyx">
                      <Play className="h-8 w-8 md:h-10 md:w-10 text-black fill-black ml-1" data-id="element-323" data-mp="32wygbuvznbjh" />
                    </div>
                  </div>
                </button>
              </> : <iframe src="https://player.vimeo.com/video/1197541389?autoplay=1&title=0&byline=0&portrait=0" className="absolute inset-0 w-full h-full" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Vantix VSL" data-id="element-324" data-mp="3bypjarz5949n" />}
          </div>
        </motion.div>
      </div>
    </section>;
}